// React and routing imports
import React from 'react'
import { Routes, Route } from 'react-router-dom';

// Components and layouts
import Home from "../pages/Public/Home/Home"
import UserLayout from '../layouts/UserLayout';
import ResetPassword from '../pages/Public/ResetPassword/ResetPassword';

// Routes accessible to non-authenticated users
const UnauthenticatePublicRoutes = () => {
  return (
    <Routes>
      {/* Main layout with home page */}
      <Route path="/" element={<UserLayout />}>
        <Route path='/' element={<Home />} />
      </Route>
      {/* Password reset page - outside main layout */}
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  )

}

export default UnauthenticatePublicRoutes